import { Card, Typography } from "antd";
import { FONT } from "constants/index";

const { Text } = Typography;

const StatCard = ({
  title,
  subtitle,
  trend,
  trendType = "up",
  icon,
  iconColor = "#09ac9c",
  tag,
  className,
}) => {
  const isUp = trendType === "up";

  return (
    <Card
      bordered={false}
      className={`stat-card ${className || ""}`.trim()}
    >
      <div className="stat-card__inner">
        <div
          className="stat-card__icon"
          style={{ backgroundColor: iconColor }}
        >
          {icon}
        </div>
        <div className="stat-card__content">
          <Text className="stat-card__value">{title}</Text>
          {subtitle && (
            <Text className="stat-card__label" style={{ fontFamily: FONT }}>
              {subtitle}
            </Text>
          )}
          {trend && (
            <Text
              type={isUp ? "success" : "danger"}
              className="stat-card__trend"
              style={{ fontFamily: FONT }}
            >
              {trend}
            </Text>
          )}
        </div>
      </div>
      {tag && (
        <Text
          type="secondary"
          className="stat-card__tag"
          style={{ fontFamily: FONT }}
        >
          {tag}
        </Text>
      )}
    </Card>
  );
};

export default StatCard;
